<template>
  <span
    class="link"
    :class="{ u: underline }"
    :style="{ '--u-offset': `${underlineOffset}px` }"
  >
    <span class="link__text" ref="link">
      <slot />
    </span>
    <span v-if="underline" class="link__underline" aria-hidden="true" />
    <span v-if="indicator" class="link__indicator" aria-hidden="true" />
  </span>
</template>

<script setup>
const { $SplitText: SplitText } = useNuxtApp();

let splitted;
let splittedMask;
const link = ref(null);
const { registerSplitText } = useAnimationCleanup();

const setupMultiline = () => {
  // Cleanup previous SplitText instance
  if (splitted) {
    splitted.revert();
  }

  setTimeout(() => {
    splitted = new SplitText(link.value, {
      type: 'lines',
      mask: 'lines',
      linesClass: 'link-line',
    });

    // Register for cleanup
    registerSplitText(splitted);

    splitted.lines.forEach((line, i) => {
      line.dataset.label = line.textContent;
      line.style.setProperty('--label', `"${line.textContent}"`);

      line.style.setProperty('--index', i);
      line.classList.add(props.align);
      const hoverText = document.createElement('span');
      hoverText.className = 'link-line__hover';
      hoverText.textContent = line.textContent;
      hoverText.setAttribute('aria-hidden', 'true');
      line.appendChild(hoverText);
    });
  }, 0);
};

const props = defineProps({
  text: { type: String, default: null },
  to: { type: String, default: null },
  href: { type: String, default: null },
  underline: { type: Boolean, default: false },
  indicator: { type: Boolean, default: false },
  align: { type: String, default: 'ta-c' },
  underlineOffset: { type: Number, default: 0 },
});

onMounted(() => {
  setupMultiline();
});
</script>

<style lang="scss" scoped>
.link {
  cursor: pointer;
  display: inline-flex;
  line-height: 100%;
  position: relative;
  width: fit-content;
  height: fit-content;

  &.u {
    padding-bottom: 0.15em;
  }

  &:hover .link__underline {
    left: 0;
    transform-origin: right;
    transform: scaleX(0);
  }

  .link__underline {
    background: currentColor;
    bottom: 0;
    height: 0.1em;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    transform-origin: left;
    transition: transform 1s ease(outExpo);
    width: 100%;
  }

  &:hover:deep(.link-line) {
    transform: translateY(-120%);
  }

  &:deep(.link-line) {
    display: inline-flex;
    position: relative;
    transition: transform 1s ease(outExpo) calc(0.1s * var(--index));
    width: 100%;
    line-height: 100%;

  }

  &:deep(.link-line__hover) {
    bottom: -120%;
    left: 0;
    position: absolute;
  }

  &:deep(.line-mask) {
    clip-path: inset(0% 0 -10% 0);
  }
}
</style>
